import { lazy, Suspense, type ReactNode } from "react";
import { createBrowserRouter } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { RequireAuth } from "@/features/auth/RequireAuth";
import { LoginPage } from "@/features/auth/LoginPage";
import { LoadingSkeleton } from "@/components/common/LoadingSkeleton";

// OS surfaces
const HomePage = lazy(() => import("@/features/home/HomePage").then((m) => ({ default: m.HomePage })));
const DashboardPage = lazy(() =>
  import("@/features/dashboard/DashboardPage").then((m) => ({ default: m.DashboardPage })),
);
const RewardsPage = lazy(() => import("@/features/rewards/RewardsPage").then((m) => ({ default: m.RewardsPage })));

// Body-recomp app surfaces
const WorkoutPage = lazy(() => import("@/features/workout/WorkoutPage").then((m) => ({ default: m.WorkoutPage })));
const ProgressPage = lazy(() => import("@/features/progress/ProgressPage").then((m) => ({ default: m.ProgressPage })));

function LazyPage({ children }: { children: ReactNode }) {
  return <Suspense fallback={<LoadingSkeleton variant="lines" lines={6} />}>{children}</Suspense>;
}

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          // OS launcher
          {
            index: true,
            element: (
              <LazyPage>
                <HomePage />
              </LazyPage>
            ),
          },
          // body-recomp app
          {
            path: "log",
            element: (
              <LazyPage>
                <WorkoutPage />
              </LazyPage>
            ),
          },
          {
            path: "progress",
            element: (
              <LazyPage>
                <ProgressPage />
              </LazyPage>
            ),
          },
          // OS surfaces
          {
            path: "score",
            element: (
              <LazyPage>
                <DashboardPage />
              </LazyPage>
            ),
          },
          {
            path: "rewards",
            element: (
              <LazyPage>
                <RewardsPage />
              </LazyPage>
            ),
          },
        ],
      },
    ],
  },
]);
